module.exports = __webpack_public_path__ + "static/media/00JOURNEY CHARA DESIGN.bb6a469b.webp";